function fetchProzoETA() {
  const pinInput = document.getElementById("prozo-pincode");
  const etaContainer = document.getElementById("prozo-eta-message");
  const pincode = pinInput?.value?.trim();

  if (!pincode || !/^\d{6}$/.test(pincode)) {
    etaContainer.innerHTML = `<small style="color:red;">Please enter a valid 6-digit pin code</small>`;
    return;
  }

  etaContainer.innerHTML = `<small>Checking delivery time...</small>`;

  fetch(`https://getprozoeta-5rloeykkpq-uc.a.run.app/?drop_pincode=${pincode}`)
    .then((response) => {
      if (!response.ok) throw new Error("Bad response");
      return response.json();
    })
    .then((data) => {
      if (data?.overallMinTAT && data?.overallMaxTAT) {
        etaContainer.innerHTML = `<small><strong>Delivery in ${data.overallMinTAT}–${data.overallMaxTAT} days</strong></small>`;
      } else {
        etaContainer.innerHTML = `<small>Delivery ETA not available</small>`;
      }
    })
    .catch((error) => {
      console.error("Prozo ETA error:", error);
      etaContainer.innerHTML = `<small style="color:green;">Could not fetch delivery time</small>`;
    });
}

document.addEventListener("DOMContentLoaded", function () {
  const prozoSection = document.getElementById("prozo-eta-widget");
  if (prozoSection && !document.getElementById("prozo-script-attached")) {
    const container =
      document.querySelector(".product__info-container, .m-product-info--wrapper") ||
      document.querySelector(".product-form");

    const html = `
      <div id="prozo-script-attached">
        <label for="prozo-pincode" style="display: block; font-weight: 500; margin-bottom: 4px;">Check Delivery ETA</label>
        <input type="text" id="prozo-pincode" placeholder="Enter your pin code" style="padding: 6px; width: 200px; border: 1px solid #ccc;" />
        <button onclick="fetchProzoETA()" style="margin-left: 6px; padding: 6px 12px;">Check</button>
        <div id="prozo-eta-message" style="margin-top: 8px; font-size: 14px; color: #2d9c4b;">
          <small>Enter pincode to check delivery time</small>
        </div>
      </div>
    `;

    container?.insertAdjacentHTML("beforeend", html);
  }
});
